import React from 'react';
import { Input, Select, Button, Space } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { FIELD_TYPES, Field } from '../types';

interface FieldRowProps {
  field: Field;
  path: number[];
  onChange: (path: number[], newField: Field) => void;
  onAdd: (path: number[], newField: Field) => void;
  onDelete: (path: number[]) => void;
}

const indentStyle = (depth: number) => ({
  marginLeft: 24 * depth,
});

export const FieldRow: React.FC<FieldRowProps> = ({
  field,
  path,
  onChange,
  onAdd,
  onDelete,
}) => {
  const depth = path.length - 1;

  const handleKeyChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    onChange(path, { ...field, key: e.target.value });

  const handleTypeChange = (value: string) => {
    let newField: Field = { ...field, type: value as any };
    if (value === 'nested') {
      newField.children = newField.children || [];
      delete newField.value;
    } else {
      delete newField.children;
      // could still assign newField.value = value === 'string' ? '' : 0;
      // but since no value input, it's not shown/used in JSON
    }
    onChange(path, newField);
  };

  const handleAddSibling = () =>
    onAdd(path.slice(0, -1), { key: '', type: 'string' });

  const handleAddChild = () =>
    onAdd(path, { key: '', type: 'string' });

  return (
    <div style={{ ...indentStyle(depth), marginBottom: 4 }}>
      <Space>
        <Input
          style={{ width: 150 }}
          placeholder="Field Name"
          value={field.key}
          onChange={handleKeyChange}
          size="small"
        />
        <Select
          style={{ width: 110 }}
          options={FIELD_TYPES}
          value={field.type}
          onChange={handleTypeChange}
          size="small"
        />
        {/* --- removed the value input here --- */}
        <Button
          icon={<DeleteOutlined />}
          danger
          size="small"
          onClick={() => onDelete(path)}
        />
        <Button
          icon={<PlusOutlined />}
          size="small"
          onClick={handleAddSibling}
        >
          Add Field
        </Button>
      </Space>
      {field.type === 'nested' &&
        <div>
          {field.children && field.children.length > 0 ? (
            field.children.map((child, idx) => (
              <FieldRow
                key={idx}
                field={child}
                path={[...path, idx]}
                onChange={onChange}
                onAdd={onAdd}
                onDelete={onDelete}
              />
            ))
          ) : null}
          <div style={{ marginLeft: 24 }}>
            <Button
              icon={<PlusOutlined />}
              size="small"
              onClick={handleAddChild}
              style={{ marginTop: 5 }}
            >
              Add Field
            </Button>
          </div>
        </div>
      }
    </div>
  );
};

export default FieldRow;
